import React from 'react';

const Testimonials = () => {
    return (
        <section id="testimonials">
            <h2>WHAT OUR CLIENTS SAY</h2>
            <div className="services-list">
                <div className="service-item">
                    <p>“Zirae Chemicals is our go-to partner for industrial acids and solvents. Their products are always delivered on time and meet our strict quality standards.”</p>
                    <strong>- Sarah, Manufacturing Plant Manager</strong>
                </div>
                <div className="service-item">
                    <p>“Their technical team helped us optimize our water treatment process with the right chemicals and support.”</p>
                    <strong>- Dr. David, Utilities Engineer</strong>
                </div>
                <div className="service-item">
                    <p>“Their marketing team helped us reach new heights. Fantastic results!”</p>
                    <strong>- Priya, Brand Manager</strong>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;